import axios from 'axios';

export const getUserRights = async () => {
  try {
    const res = await axios.get('/ticker/admin/user');
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};



export const getUsers = async () => {
  try {
    const res = await axios.get('/ticker/admin/users');
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const updateUser = async (data) => {
  try {
    const res = await axios({
      method: 'PUT',
      url: '/ticker/admin/user',
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const deleteUser = async (data) => {
  try {
    const res = await axios({
      method: 'DELETE',
      url: '/ticker/admin/user',
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const logout = async () => {
  try {
    const res = await axios({
      method: 'POST',
      url: '/ticker/admin/logout',
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const createUser = async (data) => {
  try {
    const res = await axios({
      method: 'POST',
      url: '/ticker/admin/signup',
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const logUser = async (data) => {
  try {
    const res = await axios({
      method: 'POST',
      url: '/ticker/admin/login',
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const getMainStatus = async () => {
  try {
    const res = await axios.get('/ticker/admin/database/main');
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};
export const getBackupStatus = async () => {
  try {
    const res = await axios.get('/ticker/admin/database/backup');
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const getDbSynchroStatus = async () => {
  try {
    const res = await axios.get('/ticker/admin/database/synchro/status');
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const createBackup = async (data) => {
  try {
    const res = await axios({
      method: 'POST',
      url: '/ticker/admin/database/backupfile',
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const stopReplication = async () => {
  try {
    const res = await axios({
      method: 'POST',
      url: '/ticker/admin/database/replication/stop',
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const synchroDB = async (data) => {
  try {
    const res = await axios({
      method: 'POST',
      url: '/ticker/admin/database/synchro',
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const getThemes = async () => {
  try {
    const res = await axios.get('/ticker/admin/theme');
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const createTheme = async (data) => {
  try {
    const res = await axios({
      method: 'POST',
      url: '/ticker/admin/theme',
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const updateTheme = async (data) => {
  try {
    const res = await axios({
      method: 'PUT',
      url: '/ticker/admin/theme',
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const deleteTheme = async (id) => {
  try {
    const res = await axios({
      method: 'DELETE',
      url: `/ticker/admin/theme/${id}`,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};
